// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__9UFX5","heroBody":"Hero_heroBody__4GmIr","drillBody":"Hero_drillBody__kpW-i"};